<template>
    <nio-modal
        name="conversationTemplates"
        size="lg"
        :title="$t('chat.messageInput.templatesModal.header')"
        ref="modal"
        @closed="onClosed"
    >
        <div class="flex justify-between items-center mb-4 space-x-4">
            <div class="flex-1">
                <nio-input
                    :placeholder="$t('global.general.search')"
                    type="text"
                    v-model="searchTemplate"
                >
                    <template #before>
                        <nio-icon
                            class="mr-4"
                            name="regular/search"
                        />
                    </template>
                </nio-input>
            </div>

            <nio-button
                class="hidden | xl:inline"
                tag="router-link"
                :to="{ name: 'configs.team.templates'}"
                v-if="!$configs.inIframe"
            >
                {{ $t('chat.messageInput.manage') }}
            </nio-button>
        </div>

        <div class="flex flex-col border border-gray-200 rounded">
            <div class="flex items-center px-2 py-4 border-b border-gray-200 bg-gray-200">
                <div class="flex-2 px-2">
                    {{ $t('chat.messageTemplate.headerName') }}
                </div>

                <div class="flex-1 px-2">
                    {{ $t('chat.messageTemplate.headerCategory') }}
                </div>

                <div class="hidden flex-4 px-2 | md:block">
                    {{ $t('chat.messageTemplate.headerContent') }}
                </div>

                <div class="flex-1 px-2">
                    &nbsp;
                </div>
            </div>

            <div class="flex justify-center items-center w-full p-4" v-if="!templates.length">
                {{ $t('chat.messageTemplate.noTemplate') }}
            </div>

            <div class="flex justify-center items-center w-full p-4" v-if="templates.length && !filteredTemplates.length">
                {{ $t('chat.messageTemplate.noSearchMatch') }}
            </div>

            <div
                class="flex-1 flex items-stretch px-2 py-4 hover:bg-gray-100 | group"
                :key="template.id"
                v-for="template in filteredTemplates"
            >
                <div class="flex-2 px-2 break-anywhere">
                    {{ template.name }}
                </div>

                <div class="flex-1 px-2 break-anywhere">
                    {{ getCategoryById(template.template_category_id).name }}
                </div>

                <div class="hidden flex-4 px-2 | md:block">
                    <p class="break-anywhere" v-html="nl2br(template.content[templateLocale])" />
                </div>

                <div class="flex-1 flex flex-col justify-center items-center px-2 opacity-0 | transition duration-300 ease-out group-hover:opacity-100">
                    <nio-button
                        color="blue"
                        @click="insertTemplate(template)"
                    >
                        {{ $t('chat.messageInput.templatesModal.insert') }}
                    </nio-button>
                </div>
            </div>
        </div>

        <template #footer>
            <nio-button class="flex-1" @click="close">
                {{ $t('global.general.close') }}
            </nio-button>
        </template>
    </nio-modal>
</template>

<script>
    import orderBy from 'lodash/orderBy.js';
    import { mapState, mapGetters } from 'vuex';

    export default {
        data() {
            return {
                searchTemplate: '',
            };
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            ...mapState('chat', [
                'templateCategories',
            ]),

            ...mapGetters('chat', [
                'selectedConversation',
            ]),

            templates() {
                let templates = [];

                for (const category of this.templateCategories) {
                    templates = templates.concat(category.templates);
                }

                return templates;
            },

            filteredTemplates() {
                const search = this.searchTemplate.trim();

                return orderBy(
                    this.templates.filter(t => {
                        return search == '' ||
                            this.find(t.name, search) ||
                            this.find(t.content[this.authUser.locale], search) ||
                            this.find(this.getCategoryById(t.template_category_id).name, search);
                    }),
                    'name',
                );
            },

            templateLocale() {
                if (this.selectedConversation) {
                    return this.selectedConversation.contact_phone.contact.locale;
                }

                return this.authUser.locale;
            },
        },

        methods: {
            insertTemplate(template) {
                this.$emit('insert', template);
                this.close();
            },

            getCategoryById(id) {
                return this.templateCategories.find(t => t.id == id);
            },

            onClosed() {
                this.$reset();
            },

            close() {
                this.$refs.modal.close();
            },
        },
    };
</script>
